export const links = [
  {
    label: 'Home',
    icon: 'HomeIcon',
    href: '/',
  },
  {
    label: 'Trade',
    icon: 'TradeIcon',
    items: [
      {
        label: 'Exchange',
        href: 'https://exchange.definixswap.finance',
      },
      {
        label: 'Liquidity',
        href: 'https://exchange.definixswap.finance/#/pool',
      },
    ],
  },
  {
    label: 'Farms',
    icon: 'FarmIcon',
    href: '/farms',
  },
  {
    label: 'Pools',
    icon: 'PoolIcon',
    href: '/syrup',
  },
  {
    label: 'Lottery',
    icon: 'TicketIcon',
    href: '/lottery',
  },
  {
    label: 'NFT',
    icon: 'NftIcon',
    href: '/nft',
  },
  {
    label: 'Profile & Teams',
    icon: 'GroupsIcon',
    items: [
      {
        label: 'Leaderboard',
        href: '/',
      },
      {
        label: 'YourProfile',
        href: '/',
      },
    ],
    calloutClass: 'rainbow',
  },
  {
    label: 'Info',
    icon: 'InfoIcon',
    items: [
      {
        label: 'Overview',
        href: 'https://definixswap.info',
      },
      {
        label: 'Tokens',
        href: 'https://definixswap.info/tokens',
      },
      {
        label: 'Pairs',
        href: 'https://definixswap.info/pairs',
      },
      {
        label: 'Accounts',
        href: 'https://definixswap.info/accounts',
      },
    ],
  },
  {
    label: 'IFO',
    icon: 'IfoIcon',
    items: [
      {
        label: 'Next',
        href: '/ifo',
      },
      {
        label: 'History',
        href: '/ifo/history',
      },
    ],
  },
  {
    label: 'More',
    icon: 'MoreIcon',
    items: [
      {
        label: 'Voting',
        href: 'https://voting.definixswap.finance',
      },
      {
        label: 'Github',
        href: 'https://github.com/definixswap',
      },
      {
        label: 'Docs',
        href: 'https://docs.definixswap.finance',
      },
      {
        label: 'Blog',
        href: 'https://definixswap.medium.com',
      },
    ],
  },
]

export const socials = [
  {
    label: 'Telegram',
    icon: 'TelegramIcon',
    items: [
      {
        label: 'English',
        href: 'https://t.me/definixswap',
      },
      {
        label: 'Bahasa Indonesia',
        href: 'https://t.me/DefinixSwapIndonesia',
      },
      {
        label: '中文',
        href: 'https://t.me/DefinixSwap_CN',
      },
      {
        label: 'Tiếng Việt',
        href: 'https://t.me/DefinixSwapVN',
      },
      {
        label: 'Italiano',
        href: 'https://t.me/definixswap_ita',
      },
      {
        label: 'русский',
        href: 'https://t.me/definixswap_ru',
      },
      {
        label: 'Türkiye',
        href: 'https://t.me/definixswapturkiye',
      },
      {
        label: 'Português',
        href: 'https://t.me/DefinixSwapPortuguese',
      },
      {
        label: 'Español',
        href: 'https://t.me/DefinixswapEs',
      },
      {
        label: '日本語',
        href: 'https://t.me/definixswapjp',
      },
      {
        label: 'Français',
        href: 'https://t.me/definixswapfr',
      },
      {
        label: 'Announcements',
        href: 'https://t.me/DefinixSwapAnn',
      },
      {
        label: 'Whale Alert',
        href: 'https://t.me/DefinixSwapWhales',
      },
    ],
  },
  {
    label: 'Twitter',
    icon: 'TwitterIcon',
    href: 'https://twitter.com/definixswap',
  },
]

export const MENU_HEIGHT = 64
export const FOOTER_HEIGHT = 100
export const MENU_ENTRY_HEIGHT = 40
export const SIDEBAR_WIDTH_FULL = 240
export const SIDEBAR_WIDTH_REDUCED = 56
